import script from "./AuthorForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthorForm.vue?vue&type=script&setup=true&lang=js"

import "./AuthorForm.vue?vue&type=style&index=0&id=fb85f2f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb85f2f0"]])

export default __exports__